import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { apiGet } from '../../../../api/queries/apiGet';
import { API_BASE_URL } from '../constants/consts';
import { authFirewallQueryKeys } from '../constants/queryKeys';
import { RiskyEntity } from '../../types';
import { buildUniversalMfaDomainQueryParams } from '../constants/utils';
import { QueryFiltersDomainOnly } from '../types';

const END_POINT = '/metric/riskyUsers';
const LIMIT = 9;

type RiskyUsersDto = RiskyEntity;

const convertToRiskyUsers = (data: RiskyUsersDto[]): RiskyEntity[] => {
    return data.map((item) => ({
        name: item.name,
        guid: item.guid,
        riskLevel: item.riskLevel
    }));
};

const fetchRiskyUsers = async (filters: QueryFiltersDomainOnly): Promise<RiskyUsersDto[]> => {
    const data = await apiGet<RiskyUsersDto[]>(`${API_BASE_URL}${END_POINT}`, {
        ...buildUniversalMfaDomainQueryParams(filters),
        limit: LIMIT.toString()
    });
    return data;
};

export const useRiskyUsers = (filters: QueryFiltersDomainOnly): UseQueryResult<RiskyEntity[]> => {
    return useQuery({
        queryKey: authFirewallQueryKeys.riskyUsers(filters),
        queryFn: () => fetchRiskyUsers(filters),
        select: convertToRiskyUsers
    });
};
